import { store } from '@src/state/store';
import { getCurrentGame } from '@src/state/selectors/selector_game';
import { pushEventQueue } from '@src/state/slices/slice_game';

import { Game } from '@src/lib/types';

export default () => async (data: any) => {
  try {
    if (!data || !data.gameId) return;

    const game: Game | null = getCurrentGame(store.getState());
    if (game === null)
      throw new Error('[_cannotDraw] game not found in root state');

    if (data.gameId == game.gameId) {
      console.log('CANNOT DRAW');
      store.dispatch(
        pushEventQueue({
          message: "CAN'T DRAW",
          showToast: true,
          sound: 'error',
        }),
      );
    }
  } catch (e) {
    console.log(e);
  }
};
